/**
 * Created by mh on 2017/5/24.
 */
import React, { Component } from 'react';
// import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import { injectIntl } from 'react-intl';
import { withRouter, Link } from 'react-router-dom';

import MainNavigation from './MainNavigation';
import LanguageToolbar from './LanguageToolbar';
import UserAccountToolbar from './UserAccountToolbar';

const delivermediaLogo = require('./images/delivermedia.svg');


@withRouter @observer
class NavigationTop extends Component {
    render() {
        // {match.path !== 'login' && match.path !== 'logout' &&
        // auth && !auth.isLoggedIn &&
        // !auth.isLoggingIn && // Redirecting to login if log out !
        // <Redirect to="/login" />}

        return (
            <nav className="navbar navbar-light navbar-expand-md fixed-top">
                <Link className="navbar-brand" to="/">
                    <img
                        src={delivermediaLogo}
                        className="d-inline-block align-top"
                        alt="deliver.media"
                        width="150"
                        height="40" />
                </Link>
                <button
                    className="navbar-toggler d-lg-none"
                    type="button"
                    data-toggle="collapse"
                    data-target="#navbarsMainDeliverMedia"
                    aria-controls="navbarsMainDeliverMedia"
                    aria-expanded="false"
                    aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon" />
                </button>

                <div className="collapse navbar-collapse" id="navbarsMainDeliverMedia">
                    <MainNavigation />
                    <UserAccountToolbar />
                    <LanguageToolbar />
                </div>
            </nav>
        );
    }
}

NavigationTop.propTypes = {
};

export default injectIntl(NavigationTop);
